const $$splitErrorComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_main/user/app/$appId/setting.tsx?tsr-split=errorComponent');
const $$splitComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_main/user/app/$appId/setting.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
const SettingSearchSchema = z.object({
  secret: z.coerce.number().refine(val => val === 0 || val === 1, {
    message: "secret must be 0 or 1"
  }).optional().catch(undefined)
});
export const Route = createFileRoute('/_main/user/app/$appId/setting')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent'),
  validateSearch: search => SettingSearchSchema.parse(search)
});